import { defineMessage, MessageDescriptor } from "react-intl";

export const customerFieldDescriptorsById: Record<string, MessageDescriptor> = {
  first_name: defineMessage({
    id: "customers-page.first-name",
    defaultMessage: "First name",
  }),
  last_name: defineMessage({
    id: "customers-page.last-name",
    defaultMessage: "Last name",
  }),
  position: defineMessage({
    id: "customers-page.position",
    defaultMessage: "Position",
  }),
  phone_number: defineMessage({
    id: "customers-page.phone-number",
    defaultMessage: "Phone number",
  }),
  state: defineMessage({
    id: "customers-page.state",
    defaultMessage: "State",
  }),
  country: defineMessage({
    id: "customers-page.country",
    defaultMessage: "Country",
  }),
  city: defineMessage({
    id: "customers-page.city",
    defaultMessage: "City",
  }),
  zip_code: defineMessage({
    id: "customers-page.zip-code",
    defaultMessage: "ZIP code",
  }),
  street: defineMessage({
    id: "customers-page.street",
    defaultMessage: "Street",
  }),
  company_name: defineMessage({
    id: "customers-page.company-name",
    defaultMessage: "Company name",
  }),
  industry: defineMessage({
    id: "customers-page.industry",
    defaultMessage: "Industry",
  }),
  website: defineMessage({
    id: "customers-page.website",
    defaultMessage: "Website",
  }),
  email: defineMessage({
    id: "customers-page.email",
    defaultMessage: "Email",
  }),
  lead_source: defineMessage({
    id: "customers-page.lead-source",
    defaultMessage: "Lead Source",
  }),
  last_order_placed: defineMessage({
    id: "customers-page.last-order-placed",
    defaultMessage: "Last Order Placed",
  }),
  total_purchased: defineMessage({
    id: "customers-page.total-purchased",
    defaultMessage: "Total Purchased",
  }),
};
